"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _store = require("../../redux/store");
var _deliveryDetailsSlice = require("../../redux/deliveryDetailsSlice");
var _offerSlice = require("../../redux/offerSlice");
var _orderSlice = require("../../redux/orderSlice");
var _SectionHeader = _interopRequireDefault(require("../SectionHeader"));
var _RecipientForm = _interopRequireDefault(require("./RecipientForm"));
var _DeliveryDetailsStyled = require("./DeliveryDetailsStyled");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var GiftIcon = function GiftIcon(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M27.5 7h-3.27a4.489 4.489 0 0 0-7.98-3.975L15.5 4.03l-.75-1.02A4.49 4.49 0 0 0 6.77 7H3.5a2.977 2.977 0 0 0-2.985 3L.5 26.5a2.99 2.99 0 0 0 3 3h24a2.988 2.988 0 0 0 3-3V10a2.99 2.99 0 0 0-3-3ZM20 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm-9 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm16.5 22.5h-24v-3h24v3Zm0-7.5h-24v-9h7.62L8 14.245 10.43 16 14 11.14l1.5-2.04 1.5 2.04L20.57 16 23 14.245 19.88 10h7.62v9Z",
      fill: "#BCC3CD"
    })
  });
};
GiftIcon.defaultProps = {
  width: "31",
  height: "30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var CardIcon = function CardIcon(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      opacity: ".75",
      d: "M27 0H3A2.977 2.977 0 0 0 .015 3L0 21a2.99 2.99 0 0 0 3 3h24a2.99 2.99 0 0 0 3-3V3a2.99 2.99 0 0 0-3-3Zm0 21H3v-9h24v9Zm0-15H3V3h24v3Z",
      fill: "#BCC3CD"
    })
  });
};
CardIcon.defaultProps = {
  width: "30",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const DeliveryDetails = _ref => {
  let {
    giftable
  } = _ref;
  const dispatch = (0, _store.useAppDispatch)();
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    isGift
  } = (0, _store.useAppSelector)(_deliveryDetailsSlice.selectDeliveryDetails);
  const {
    id: orderId
  } = (0, _store.useAppSelector)(_orderSlice.selectOnlyOrder);
  const handleSetIsGift = () => {
    dispatch((0, _deliveryDetailsSlice.setIsGift)(true));
    dispatch((0, _orderSlice.fetchUpdateOrder)({
      id: orderId,
      payload: {
        buyAsAGift: true
      }
    })).unwrap().catch(err => {
      throw new Error(err);
    });
  };
  const handleSetIsNotGift = () => {
    dispatch((0, _deliveryDetailsSlice.setIsGift)(false));
    dispatch((0, _orderSlice.fetchUpdateOrder)({
      id: orderId,
      payload: {
        buyAsAGift: false
      }
    })).unwrap().catch(err => {
      throw new Error(err);
    });
  };
  const {
    offer: {
      accessGranted
    }
  } = (0, _store.useAppSelector)(_offerSlice.selectOffer);
  (0, _react.useEffect)(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const purchaseAsGiftParam = urlParams.get('purchaseAsGift');
    if (accessGranted || purchaseAsGiftParam === 'true') {
      handleSetIsGift();
    } else {
      handleSetIsNotGift();
    }
    return () => {
      dispatch((0, _deliveryDetailsSlice.resetDeliveryDetailsState)());
    };
  }, [accessGranted, window.location.search]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_DeliveryDetailsStyled.DeliveryDetailsStyled, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SectionHeader.default, {
      marginTop: "25px",
      center: true,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
        children: t('deliverydetails.title', 'Delivery details')
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_DeliveryDetailsStyled.ButtonsContainer, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_DeliveryDetailsStyled.StyledButton, {
        isActive: !isGift,
        onClick: handleSetIsNotGift,
        disabled: accessGranted,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(CardIcon, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
          children: t('deliverydetails.button.purchase-for-myself', 'Purchase for myself')
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_DeliveryDetailsStyled.StyledButton, {
        isActive: isGift,
        onClick: handleSetIsGift,
        disabled: !giftable,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(GiftIcon, {}), t('deliverydetails.button.purchase-as-gift', 'Purchase as a gift')]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
      children: isGift && /*#__PURE__*/(0, _jsxRuntime.jsx)(_RecipientForm.default, {})
    })]
  });
};
var _default = exports.default = DeliveryDetails;